import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal, ViewChild, AfterViewInit, OnInit, ElementRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatNavList } from '@angular/material/list';
import { Router, RouterModule } from '@angular/router';
import { MenuItemComponent } from "./menu-item/menu-item.component";
import { MatIcon } from "@angular/material/icon";
import { MatSidenavContainer, MatSidenavContent, MatSidenav } from "@angular/material/sidenav";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LanguageSelectorComponent } from "../language-selector/language-selector.component";
import { LoadingService } from '../../services/loading.service';
import { AccessMenuItem } from 'src/app/interfaces/users/access.interface';
import { TranslateModule } from '@ngx-translate/core';
import { SelectComponent } from "../select/select.component";
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from 'src/app/services/users/user.service';
import { ISelectOption } from 'src/app/interfaces/components/select.interface';
import { MY_DATA_MENU_ITEMS } from 'src/app/panels/panel.constants';
import { RefreshHomeService } from 'src/app/services/refresh-home.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    MatNavList,
    CommonModule,
    RouterModule,
    MenuItemComponent,
    MatIcon,
    MatSidenavContainer,
    MatSidenavContent,
    MatSidenav,
    MatButtonModule,
    MatProgressSpinnerModule,
    LanguageSelectorComponent,
    TranslateModule,
    SelectComponent
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})

export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;

  private readonly loadingService = inject(LoadingService);
  private readonly elementRef = inject(ElementRef);
  private readonly fb = inject(FormBuilder);
  private readonly userService = inject(UserService);
  private readonly refreshHomeService = inject(RefreshHomeService);
  private readonly router = inject(Router);

  name = sessionStorage.getItem('name');
  role = sessionStorage.getItem('role');

  enterpriseOptions: ISelectOption[] = [];

  form: FormGroup = this.fb.group({
    enterprise: [sessionStorage.getItem('personId') ?? ''],
  });

  menuItems = input.required<AccessMenuItem[]>();

  displayMenuItems: AccessMenuItem[] = [];

  collapsed = signal(false);
  sidNavWidth = computed(() => (this.collapsed() ? '65px' : '250px'));

  adjustedData = false;

  loading = toSignal(this.loadingService.loading$);

  ngOnInit(): void {
    this.getEnterprises();
  }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.classList.add('loaded');
  }

  getEnterprises(): void {
    this.userService.getEnterprises().subscribe((res) => {
      if (!res.data) {
        return;
      }

      const enterprises = Array.isArray(res.data)
        ? res.data
        : res.data.enterprises ?? [];

      this.enterpriseOptions = enterprises.map((item: any) => ({
        value: item.id,
        label: item.name,
        adjustedData: item.adjustedData,
        isBrf: item.isBrf,
      }));

      const selectedEnterprise = enterprises.find(
        (item: any) => item.id === this.form.get('enterprise')?.value
      );

      sessionStorage.setItem('isBrf', selectedEnterprise.isBrf);

      this.verifyAdjustedData(
        selectedEnterprise?.adjustedData ?? false
      );
    });
  }

  onChangeEnterprise(event: any): void {
    if (!event?.value) {
      return;
    }

    this.router.navigate(['/panel/home']);

    sessionStorage.setItem('personId', event.value);
    sessionStorage.setItem('isBrf', event.isBrf);
    this.verifyAdjustedData(event.adjustedData);
  }

  verifyAdjustedData(adjustedData: boolean) {
    if (this.role !== 'Admin') {
      this.displayMenuItems = [...this.menuItems()];
      return;
    }

    if (adjustedData === false) {
      this.displayMenuItems = MY_DATA_MENU_ITEMS;
      sessionStorage.setItem('adjustedData', 'false');
      this.refreshHomeService.refreshHome();
    } else {
      this.displayMenuItems = [...this.menuItems()];
      sessionStorage.setItem('adjustedData', 'true');
    }
  }
}
